import { EServiceId, EUnavailableReason } from '../../../types/reducers/publishTerms';

export interface IPromotionState {
  toggle: IPromotionToggle;
  moderation: {
    isAllowed: boolean;
    unavailableReasonType: EUnavailableReason | null;
  };
  auctionBet: IAuctionBet;
  duration: IDurationState;
  services: IPromotionService[];
  banner?: {
    promotionTypeChangeReason: string | null;
  };
  competitors: ICompetitorService[];
  isChangedByUser: boolean;
}

interface IPromotionToggle {
  checked: boolean;
  disabled: boolean;
}

export interface IAuctionBet {
  readonly available: boolean;
  value: number;
  step: number;
  minBet: number;
  maxBet: number;
  token: string;
  // @deprecated
  previousBets: number[];
  // @deprecated
  nextBets: number[];
}

export interface IDurationState {
  defaultDuration: number;
  durations: IDuration[];
}

export interface IDuration {
  durationInDays: number;
  discountPercent: number;
  selected: boolean;
}

export interface IPromotionService {
  type: EServiceId;
  price: number;
  selected: boolean;
  token: string;
  disabled: boolean;
  isAuctionEnabled: boolean;
  isRecommended: boolean;
  unavailableReasonType: EUnavailableReason | null;
}

export const enum ECompetitorsLevel {
  high = 'high',
  medium = 'medium',
  low = 'low',
}

export const enum ECompetitorsPromotionType {
  noPromotion = 'noPromotion',
  standard = 'standard',
  premium = 'premium',
  top = 'top',
  topWithBet = 'topWithBet',
}

export interface ICompetitorService {
  promotionType: ECompetitorsPromotionType;
  amount: number;
  competitionLevel: ECompetitorsLevel;
}
